// extracted by mini-css-extract-plugin
export var aboveInput = "_me-0";
export var actionButton = "_me-5";
export var actionButtonContainer = "_me-1";
export var actionIcon = "_me-6";
export var aiInfoContainer = "_me-2";
export var attachmentWrapper = "_me-7";
export var bold = "_me-3";
export var checkIcon = "_me-8";
export var clickingRecipientBar = "_me-11";
export var commentThreadSwitch = "_me-a";
export var draftImage = "_me-b";
export var draftImageContainer = "_me-c";
export var draftImages = "_me-e";
export var editButton = "_me-g";
export var editor = "_me-f";
export var editorContainer = "_me-y";
export var editorErrorTooltipWrapper = "_me-9";
export var headerDivider = "_me-h";
export var icon = "_me-i";
export var info = "_me-j";
export var internal = "_me-n";
export var internalDivider = "_me-k";
export var internalMessage = "_me-l";
export var messageInputCard = "_me-m";
export var messageInputForm = "_me-o";
export var messageInputFormInternal = "_me-p";
export var options = "_me-q";
export var publicMessageCustomer = "_me-s";
export var publicMessageMerchant = "_me-r";
export var removeImageButton = "_me-d";
export var replyButtons = "_me-t";
export var showSignatureButton = "_me-u";
export var spinner = "_me-v";
export var verticalButtonDivider = "_me-4";
export var visibilitySelector = "_me-w";
export var warning = "_me-x";
export var wrappingText = "_me-z";
export var writingInternalNoteTopBorder = "_me-10";